export default __webpack_public_path__ + "static/html-icon-e4d7298cddb13d962b068808d0c600a7.svg";